import React from 'react';
import * as auth from 'ducks/auth';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LOGIN_PAGE } from 'new-design/routes/common/constants';
import { useEventTypeAccess } from 'new-design/hooks/useEventTypeAccess';

export const PermissionRoute = ({ component: Component, permission, eventType, ...rest }) => {
  const { sessionID } = useSelector(auth.selectors);
  const hasPermission = useSelector(auth.hasPermission);
  const isContact = useSelector(auth.isContact);
  const { isLoaded: eventTypesLoaded, hasEventType } = useEventTypeAccess();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!sessionID) {
          return (
            <Redirect
              to={{
                pathname: LOGIN_PAGE,
                state: { from: props.location },
              }}
            />
          );
        }

        if (permission && !hasPermission(permission)) {
          return (
            <Redirect
              to={{
                pathname: '/app/control-panel',
                state: { from: props.location },
              }}
            />
          );
        }

        // Contacts whose `Event Types` setting excludes this page's event type
        // must not reach it by URL either. Wait for the event types to load
        // before deciding, otherwise a direct hit would always redirect.
        if (eventType && isContact) {
          if (!eventTypesLoaded) return null;

          if (!hasEventType(eventType)) {
            return (
              <Redirect
                to={{
                  pathname: '/app/control-panel',
                  state: { from: props.location },
                }}
              />
            );
          }
        }

        return <Component {...props} />;
      }}
    />
  );
};
